import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { LocalizeProvider } from 'react-localize-redux';
import { SERVICE_WORKER_UPDATE } from './actions/actions';
import { Store } from './data/store';
import Middleware from './data/middleware';
import SetupCall from './data/setupcall';
import * as serviceWorker from './serviceWorker';

import App from './App';

const renderApp = () =>
    render(
        <Provider store={Store}>
            <LocalizeProvider>
                <App />
            </LocalizeProvider>
        </Provider>,
        document.getElementById('root')
    );

if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('./App', renderApp);
}

const serviceWorkerConfig = {
    onUpdate: (reg) => Store.dispatch({ type: SERVICE_WORKER_UPDATE, payload: reg })
};

serviceWorker.register(serviceWorkerConfig);
Middleware.ConfigureAllMiddleware();
SetupCall.configureAllSetupCall();
renderApp();
